import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"
import { PAGE_HANDOFF_KEY, PAGE_RESULT_KEY, readStored } from "../src/search_picker_page"

// The page a native modal pushes for a search picker. It rebuilds the opener's
// select as an inline picker, and Done hands the choices back and returns to
// the opener by its own URL, which the native navigators treat as going back.
export default class extends Controller {
  static targets = ["picker", "missing", "clear"]

  connect() {
    this.handoff = readStored(PAGE_HANDOFF_KEY)
    this.missingTarget.hidden = !!this.handoff
    if (!this.handoff) return

    const select = document.createElement("select")
    select.name = this.handoff.name
    select.multiple = this.handoff.multiple
    if (this.handoff.placeholder) select.setAttribute("placeholder", this.handoff.placeholder)
    for (const [name, value] of this.handoff.config) select.setAttribute(name, value)
    select.dataset.controller = "search-picker"
    select.setAttribute("data-search-picker-inline-value", "true")
    for (const { value, text } of this.handoff.options) select.add(new Option(text, value, true, true))
    this.pickerTarget.replaceChildren(select)
    this.select = select
    select.addEventListener("change", () => this.updateClear())
    this.updateClear()
  }

  clear() {
    if (!this.select) return
    for (const option of this.select.options) option.selected = false
    this.select.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // The native nav bar's Clear only shows while something is chosen.
  updateClear() {
    const chosen = Array.from(this.select.selectedOptions).some(option => option.value !== "")
    for (const button of this.clearTargets) button.setAttribute("data-bridge--button-visible-value", String(chosen))
  }

  done() {
    if (!this.handoff) return
    const options = Array.from(this.select.selectedOptions)
      .filter(option => option.value !== "")
      .map(option => ({ value: option.value, text: option.textContent }))
    const { returnUrl, name, form } = this.handoff
    try {
      sessionStorage.setItem(PAGE_RESULT_KEY, JSON.stringify({ returnUrl, name, options, form }))
      sessionStorage.removeItem(PAGE_HANDOFF_KEY)
    } catch {
      return
    }
    Turbo.visit(returnUrl)
  }
}
